import { Texto } from '@gravitate-js/excalibrr'
import { theme } from 'antd'
import { AttachmentChip } from './AttachmentChip'

export type InlineChartProps = {
  taskId: string
  filename: string
  mimeType: string
  sizeBytes: number
}

/**
 * STUB (v1): Plotly is not bundled in Crossroads, so inline interactive charts
 * are not rendered yet. We surface a small "charts not yet supported" note and
 * fall back to a download chip for the underlying `.plotly.json` artifact so the
 * data is still reachable.
 *
 * The full Plotly-rendering implementation lives in S&D
 * (`InlineChart.tsx` + `PlotlyChart.tsx`); port it here once a chart library is
 * adopted in Crossroads.
 */
export function InlineChart({
  taskId,
  filename,
  mimeType,
  sizeBytes,
}: InlineChartProps) {
  const { token } = theme.useToken()
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        border: `1px dashed ${token.colorBorderSecondary}`,
        borderRadius: 10,
        padding: 10,
        background: token.colorFillQuaternary,
      }}
    >
      <Texto appearance='hint' style={{ fontSize: 11 }}>
        Inline charts are not yet supported in Crossroads — download the chart
        data instead.
      </Texto>
      <AttachmentChip
        taskId={taskId}
        filename={filename}
        mimeType={mimeType}
        sizeBytes={sizeBytes}
      />
    </div>
  )
}
